import React from 'react';
import {ListAllLevelsLevelType} from '../../../types/TypesUserProfit';
import LevelListElement from './LevelListElement.new';
import {useTranslation} from 'react-i18next';
import {useGetListAllLevelsQuery} from '../../../redux/userClientsApi';
import PreLoaderComponent from '../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import styles from './LevelsList.new.module.css';

const LevelsList = ({month}: {month: string}) => {
	const {t} = useTranslation();
	const {data, isFetching} = useGetListAllLevelsQuery(month);
	const isEmpty = data && data.levels.length === 0;

	if (isFetching) {
		return (
			<div className={styles.loadingWrapper}>
				<PreLoaderComponent type="gallery" size="big" />
			</div>
		);
	}

	if (isEmpty) {
		return (
			<div className={styles.emptyState}>
				<span className={styles.emptyIcon}>📊</span>
				<div className={styles.emptyText}>
					{t('Бонуси за цей місяць відсутні')}
				</div>
			</div>
		);
	}

	if (data?.levels) {
		return (
			<div className={styles.levelsWrapper}>
				{data.levels.map((level: ListAllLevelsLevelType) => (
					<LevelListElement level={level} key={level.level} />
				))}
			</div>
		);
	}

	return null;
};

export default LevelsList;

